/**
 * 施設利用状況を表示するコンポーネント
 */
import { useEffect, useState } from "react";
import { SeatStatus } from "./types/TypeMapData";
import { Card } from "@chakra-ui/react";
import Map from "./Map";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../css/spinner.scss";
import "../css/GridPatternUsageInfo.scss";
import { generateUsageInfoList } from "./utils/generateUsageInfoList";
import { Apihost } from "./utils/Apihost";

const GridPatternUsageInfo: React.FC = () => {
  const [data, setData] = useState<any>([]);
  const [seatStatus, setSeatStatus] = useState<SeatStatus[]>([]);
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const apihostIst = Apihost("ist");
  useEffect(() => {
    setIsFetching(true);
    fetch(`${apihostIst}/api/get-available-objects-now`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "DONT_PANIC",
      },
      body: JSON.stringify({ SORT_FOR_SIGNAGE: true }),
    })
      .then((response) => response.json())
      .then((res) => {
        let json = generateUsageInfoList(res.data.equipments_status);
        console.log("json", json);
        setSeatStatus(res.data.seats_status);
        setData(json);
        setIsFetching(false);
        console.log(res.data);
      })
      .catch((error) => {
        console.log("データの取得に失敗しました", error);
      });
  }, []);
  return (
    <div
      className="App-left-component"
      id="grid-pattern-usage"
      style={{
        position: "absolute",
        width: window.innerHeight > window.innerWidth ? "100%" : "80%",
      }}
    >
      <div id="card_map" className="card card_map">
        <Map seatStatus={seatStatus} isFetching={isFetching} />
      </div>
      <div id="card_usage_table" className="card card_usage_table">
        <Card className="card_outer">
          <div className="usage_table_left_container">
            <div className="usage_table_title">
              <span className="commons">備品利用状況</span>
            </div>
          </div>
          <div className="usage_table_right_container">
            <div className="full_container">
              {(() => {
                if (!isFetching) {
                  return (
                    <>
                      <Swiper
                        slidesPerView={1}
                        spaceBetween={30}
                        loop={true}
                        pagination={{
                          clickable: true,
                        }}
                        navigation={true}
                        autoplay={{
                          delay: 6000,
                          disableOnInteraction: false,
                        }}
                        speed={1000}
                        modules={[Pagination, Navigation, Autoplay]}
                        className="swiper"
                        style={{ width: "100%", height: "100%" }}
                      >
                        {data.map((item: any, index: number) => (
                          <SwiperSlide key={index}>{item.content}</SwiperSlide>
                        ))}
                      </Swiper>
                    </>
                  );
                } else {
                  return (
                    <div className="swiper" style={{ height: "100%" }}>
                      <table>
                        <tbody>
                          <tr>
                            <th className="table_main">備品名</th>
                            <th className="table_sub">
                              <span>利用状況</span>
                            </th>
                            <th className="table_main">備品名</th>
                            <th className="table_sub">
                              <span>利用状況</span>
                            </th>
                          </tr>
                          {[...Array(5)].map((_, index) => (
                            <tr key={index}>
                              <td className="table_main"></td>
                              <td className="table_sub">
                                <span className="molecule"></span>
                                <span className="slash">/</span>
                                <span className="denominator"></span>
                              </td>
                              <td className="table_main"></td>
                              <td className="table_sub">
                                <span className="molecule"></span>
                                <span className="slash">/</span>
                                <span className="denominator"></span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  );
                }
              })()}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default GridPatternUsageInfo;
